export const maxBorrowBuilderForMilli = (maxBorrow) => {
  return {
    lenderId: Number(maxBorrow.LenderID || maxBorrow.LenderId),
    lenderCode: maxBorrow.LenderName,
    maximumLoanAmount: maxBorrow.MaxLoanAmount,
  };
};
